import React from 'react';
import './MostrarFelicidades.css';

const MostrarFelicidades = ({aparato, nombre, club}) => {

    return (
        <div className={`fondo-felicidades ${aparato?.toLowerCase()}`}>

            <div className='fila-felicidades'>
                {/* logo colegio */}
                {club && (
                    <img className="imagen-colegio-fig" src={`/images/${club}.jpg`}/>
                )}
                {/* nombre */}
                {nombre && (
                    <p className='nombre-atleta-fig'>{nombre}</p>
                )}
                </div>
                
                <div className='fila-puntaje-felicidades'>

                    <p className='puntaje-atleta-felicidades'>10,000</p>
            
                </div>

            </div>
    );
};

export default MostrarFelicidades;